/* eslint-disable @typescript-eslint/no-explicit-any */
import { getByID, getDocument, getSingle } from ".";
import { appLocales, getPrismicLocale } from "../i18n";

type PrismicDataResolution = Pick<Resolution, "locale" | "templateName" | "slugs">;

export const getData = async (resolution: PrismicDataResolution): Promise<any> => {
  try {
    const { templateName, slugs, locale } = resolution;

    if (
      templateName === "product" ||
      templateName === "page" ||
      templateName === "categorie" ||
      templateName === "categories" ||
      templateName === "tables" ||
      templateName === "inspiration_category" ||
      templateName === "about" ||
      templateName === "tag" ||
      templateName === "inspiration"
    ) {
      const documentType =
        templateName === "about" ? "page" : templateName === "categories" ? "categorie" : templateName;
      let slug = slugs.join("/");

      if (documentType === "categorie") {
        // Take the last slug for category documents
        slug = slugs[slugs.length - 1];
      }

      const data = await getDocument(documentType, slug, locale);

      let translation = null;

      // if (resolution.locale !== appLocales.defaultLocale) {
      const alternate = data?.alternate_languages?.find(
        (lang) => lang.lang === getPrismicLocale(appLocales.defaultLocale)
      );

      if (alternate) {
        translation = await getByID(alternate.id);
      }
      // }

      return {
        ...data,
        translation,
      };
    }

    if (
      templateName === "homepage" ||
      templateName === "archive_inspiration" ||
      templateName === "archive_table" ||
      templateName === "contact"
    ) {
      const data = await getSingle(templateName, locale);

      const translation = null;

      return {
        ...data,
        translation,
      };
    }

    if (templateName === "search") {
      return {
        lang: getPrismicLocale(locale),
        translation: null,
      };
    }

    if (templateName === "faq") {
      // Get by "slug" and FAQ type
      const slug = slugs.join("/");
      const data = await getDocument("faq", slug, locale);

      let translation = null;

      // if (resolution.locale !== appLocales.defaultLocale) {
      const alternate = data?.alternate_languages?.find(
        (lang) => lang.lang === getPrismicLocale(appLocales.defaultLocale)
      );

      if (alternate) {
        translation = await getByID(alternate.id);
      }

      return {
        ...data,
        translation,
      };
    }

    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const getField = (key: string, document: any): any => {
  if (!document) return null;

  return document?.translation?.data?.[key] || document?.data?.[key];
};
